export default "__VITE_ASSET__1ec10913__"